import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Jumbotron, Button, Row, FormControl, Col, ControlLabel } from 'react-bootstrap';
import { Column, Table } from 'react-virtualized';
import _ from 'lodash';

import DeleteModal from '../../modals/DeleteModal.js';
import { gettext } from '../../../i18n/service.js';
import * as settingsActions from '../../../actions/settingsActions';
import * as appActions from '../../../actions/appActions';
import * as fleetActions from '../../../actions/fleetOwnerActions';

class ApiComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      createWebHook: false,
      editWebHook: false,
      selectedWebHook: null,
      options: ['orderId', 'dispatcherId', 'role', 'updatedAt', 'status', 'action'],
      event: 'order-status-change',
      outputFormat: 'json',
      headers: "",
      integrations: [],
      orderId: null,
      dispatcherId: null,
      role: null,
      updatedAt: null,
      status: null,
      action: null,
      fields: "orderId"
    };

    this.createNewWebHook = this.createNewWebHook.bind(this);
    this.deleteWebHook = this.deleteWebHook.bind(this);
    this.updateWebHook = this.updateWebHook.bind(this);
    this.flipCreateWebHook = this.flipCreateWebHook.bind(this);
    this.flipEditWebHook = this.flipEditWebHook.bind(this);
    this.updateSelectedWebHook = this.updateSelectedWebHook.bind(this);
  }

  componentDidMount() {
    this.props.appActions.startSpinner();
    this.props.appActions.getTokens(this.props.account.id, this.props.appActions.endSpinner);
    // this.props.settingsActions.getWebHooks(this.props.company.id, this.props.appActions.endSpinner);
  }

  componentWillReceiveProps(nextProps) {
    // if(nextProps.webHooks !== this.props.webHooks) {
    //   this.setState({ createWebHook: false, editWebHook: false, selectedWebHook: null });
    // }     
  }

  createNewWebHook() {
    const data = {
      event: this.state.event,
      integrations: this.state.integrations
    };
    this.props.settingsActions.createNewWebHook(data, this.props.company.id);
  }

  deleteWebHook(id) {
    this.props.settingsActions.deleteWebHook(this.props.company.id, id);
  }

  updateWebHook() {    
    const { selectedWebHook } = this.state;
    this.props.settingsActions.updateWebHook(this.props.company.id, selectedWebHook.id, selectedWebHook);
  }

  createNewDookFields() {
    let { integrations } = this.state;
    integrations.push(
      {
        headers: this.state.headers,
        callbackUrl: "https://webhook.site/b2831705-6949-4f93-842f-307cce76b41c",
        outputFormat: this.state.outputFormat,
        fields:{
          action: null,
          orderId: null,
          dispatcherId: null,
          role: null,
          updatedAt: null
        }
      }
    );
    this.setState({ integrations });
  }  

  setFields(fields, values, index) {
    let { integrations } = this.state;
    integrations[index] = {
      headers: this.state.headers,
      callbackUrl: "https://webhook.site/b2831705-6949-4f93-842f-307cce76b41c",
      outputFormat: this.state.outputFormat,
      fields:{
        action: fields == 'actions' ? values: null,
        orderId: fields == 'orderId' ? values: null,
        dispatcherId: fields == 'dispatcherId' ? values: null,
        role: fields == 'role' ? values: null,
        updatedAt: fields == 'updatedAt' ? values: null
      }
    };

    this.setState({ integrations });
  }

  insertNewDookFields() {
    let { selectedWebHook } = this.state;
    selectedWebHook.integrations.push(
      {
        headers: this.state.headers,
        callbackUrl: "https://webhook.site/b2831705-6949-4f93-842f-307cce76b41c",
        outputFormat: this.state.outputFormat,
        fields:{
          action: null,
          orderId: null,
          dispatcherId: null,
          role: null,
          updatedAt: null
        }
      }
    );

    this.setState({ selectedWebHook });
  }

  updateSelectedWebHook(value, field, index) {
    let { selectedWebHook } = this.state;
    selectedWebHook.integrations[index].fields[field] = value;
    this.setState({ selectedWebHook });
  }

  removeDookFields(rowIndex) {
    let { integrations } = this.state;
    integrations.splice(rowIndex, 1);
    this.setState({ integrations });
  }

  getSelectedWebHook(row) {
    this.setState({ selectedWebHook: row });
    this.setState({ createWebHook: false });
  }

  flipCreateWebHook() {
    this.setState({ createWebHook: true });
    this.setState({ selectedWebHook: null });
  }

  flipEditWebHook() {
    this.setState({ editWebHook: true });
    this.setState({ createWebHook: false });
  }

  renderWebHooks() {
    this.state.createWebHook = true;
    const { selectedWebHook } = this.state;

    return(
      <Jumbotron className="position_relative">
        <div className="text_align_center margin_bottom_em item_head_title">
          <h3>{gettext('NEW-OPERATOR')}</h3>
        </div>
        <div className="user_data center_div ">
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Event Type</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <ControlLabel><h4>{selectedWebHook.event}</h4></ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Output Type</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <ControlLabel><h4>{selectedWebHook.integrations[0].outputFormat}</h4></ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Target URL</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <ControlLabel><h4>{selectedWebHook.integrations[0].url}</h4></ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Headers</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <ControlLabel><h4>{selectedWebHook.integrations[0].headers}</h4></ControlLabel>
            </Col>
          </Row>                 
        </div>
        <div className="botom_line" />
        <div className="text_align_center margin_bottom_em item_head_title">
          <h3>Properties to Send</h3>
        </div>
        <div className="user_data center_div">
          <Row>
            <Col sm={6}>
              <div className="text_align_center margin_bottom_em">
                <h4>Dook Fields</h4>
              </div>
            </Col>
            <Col sm={6}>
              <div className="text_align_center margin_bottom_em">
                <h4>Target Names</h4>
              </div>              
            </Col>
          </Row>
          {
            _.map(selectedWebHook.integrations, (integration, rowIndex) => (
              <Row key={rowIndex}>
                {
                  !_.isNil(integration.fields.action) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <ControlLabel><h4>Action</h4></ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <ControlLabel><h4>{integration.fields.action}</h4></ControlLabel>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.orderId) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <ControlLabel><h4>OrderId</h4></ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <ControlLabel><h4>{integration.fields.orderId}</h4></ControlLabel>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.dispatcherId) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <ControlLabel><h4>DispatcherId</h4></ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <ControlLabel><h4>{integration.fields.dispatcherId}</h4></ControlLabel>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.role) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <ControlLabel><h4>Role</h4></ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <ControlLabel><h4>{integration.fields.role}</h4></ControlLabel>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.updatedAt) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <ControlLabel><h4>UpdatedAt</h4></ControlLabel>
                    </Col>
                    <Col sm={6}>
                      <ControlLabel><h4>{integration.fields.updatedAt}</h4></ControlLabel>
                    </Col>
                  </Col>
                }                
              </Row>      
            ))
          }
        </div>
        <div className="edit_link">
          <a onClick={() => this.flipEditWebHook()}><h4>{gettext('EDIT')}</h4></a>
        </div>
      </Jumbotron>
    );
  }

  renderCreateWebHooks() {
    this.state.createWebHook = true;
    const { integrations, options } = this.state;
    return(
      <Jumbotron className="position_relative">
        <div className="text_align_center margin_bottom_em item_head_title">
          <h3>{gettext('NEW-OPERATOR')}</h3>
        </div>
        <div className="user_data center_div ">
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Event Type</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                componentClass="select" placeholder="Order Status Change"
                onChange={(e) => this.setState({event: e.target.value})}>
                <option value="order-status-change">Order Status Change</option>
              </FormControl>  
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Output Type</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                componentClass="select" placeholder="Order Status Change"
                onChange={(e) => this.setState({outputFormat: e.target.value})}>
                <option value="json">Application/JSON</option>
              </FormControl> 
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Target URL</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                type="text"
                required={true}
                onChange={(e) => this.setState({url: e.target.value})}/>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Headers</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                componentClass="textarea"
                onChange={(e) => this.setState({headers: e.target.value})}/>
            </Col>
          </Row>                 
        </div>
        <div className="botom_line" />
        <div className="text_align_center margin_bottom_em">
          <h3>Properties to Send</h3>
        </div>
        <div className="user_data center_div">
          <Row>
            <Col sm={6}>
              <div className="text_align_center margin_bottom_em">
                <h4>Dook Fields</h4>
              </div>
            </Col>
            <Col sm={6}>
              <div className="text_align_center margin_bottom_em">
                <h4>Target Names</h4>
              </div>              
            </Col>
          </Row>
          {
            _.map(integrations, (row, rowIndex) => (
              <Row key={rowIndex}>
                <Col sm={6}>
                  <FormControl
                    className="custom-select"
                    componentClass="select"
                    onChange={(e) => this.setState({fields: e.target.value})}>
                    {                      
                      _.map(options, (option, index) => (
                        <option key={index} value={option}>{option}</option>
                      ))
                    }
                    
                  </FormControl>
                </Col>
                <Col sm={6}>
                  <div className="display_flex">
                    <FormControl
                      type="text"
                      required={true}
                      onChange={(e) => this.setFields(this.state.fields, e.target.value, rowIndex)}
                      placeholder="Enter the target name"/>
                    <Button className="multi_btn margin_bottom_halfem" onClick={() => {this.removeDookFields(rowIndex);}}>-</Button>
                  </div>
                </Col>
              </Row>
            ))
          }
          <Row>
            <Col sm={12}>
              <Button className="float_right_btn" onClick={() => {this.createNewDookFields();}}>+</Button>
            </Col>
          </Row>
        </div>
        <div className="actions">
          <Button bsStyle="primary" onClick={() => this.createNewWebHook()}>{gettext('SAVE')}</Button>
        </div>
      </Jumbotron>
    );
  }

  renderEditWebHooks() {
    const { selectedWebHook, integrations, options } = this.state;

    return(
      <Jumbotron className="position_relative">
        <div className="text_align_center margin_bottom_em item_head_title">
          <h3>{gettext('NEW-OPERATOR')}</h3>
        </div>
        <div className="user_data center_div ">
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Event Type</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                componentClass="select" placeholder="Order Status Change"
                defaultValue={selectedWebHook.event}
                onChange={(e) => this.setState({event: e.target.value})}>
                <option value="order-status-change">Order Status Change</option>
              </FormControl>  
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Output Type</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                componentClass="select" placeholder="Order Status Change"
                defaultValue={selectedWebHook.integrations[0].outputFormat}
                onChange={(e) => this.setState({outputFormat: e.target.value})}>
                <option value="json">Application/JSON</option>
              </FormControl> 
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Target URL</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                type="text"
                required={true}
                onChange={(e) => this.setState({url: e.target.value})}/>
            </Col>
          </Row>
          <Row>
            <Col sm={4}>
              <ControlLabel><h4>Headers</h4></ControlLabel>
            </Col>
            <Col sm={8}>
              <FormControl
                componentClass="textarea"
                defaultValue={selectedWebHook.integrations[0].headers}
                onChange={(e) => this.setState({headers: e.target.value})}/>
            </Col>
          </Row>                 
        </div>
        <div className="botom_line" />
        <div className="text_align_center margin_bottom_em">
          <h3>Properties to Send</h3>
        </div>
        <div className="user_data center_div">
          <Row>
            <Col sm={6}>
              <div className="text_align_center margin_bottom_em">
                <h4>Dook Fields</h4>
              </div>
            </Col>
            <Col sm={6}>
              <div className="text_align_center margin_bottom_em">
                <h4>Target Names</h4>
              </div>              
            </Col>
          </Row>
          {
            _.map(selectedWebHook.integrations, (integration, rowIndex) => (
              <Row key={rowIndex}>
                {
                  !_.isNil(integration.fields.action) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <FormControl
                        className="custom-select"
                        componentClass="select"
                        defaultValue="action"
                        onChange={(e) => console.log(e.target.value)}>
                        {                      
                          _.map(options, (option, index) => (
                            <option key={index} value={option}>{option}</option>
                          ))
                        }
                      </FormControl>
                    </Col>
                    <Col sm={6}>
                      <div className="display_flex">
                        <FormControl
                          type="text"
                          defaultValue={integration.fields.action}
                          onChange={(e) => this.updateSelectedWebHook(e.target.value, 'action', rowIndex)}/>
                        <Button className="multi_btn margin_bottom_halfem" onClick={() => {this.removeDookFields(rowIndex);}}>-</Button>
                      </div>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.orderId) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <FormControl
                        className="custom-select"
                        componentClass="select"
                        defaultValue="orderId"
                        onChange={(e) => this.setState({fields: e.target.value})}>
                        {                      
                          _.map(options, (option, index) => (
                            <option key={index} value={option}>{option}</option>
                          ))
                        }
                      </FormControl>
                    </Col>
                    <Col sm={6}>
                      <div className="display_flex">
                        <FormControl
                          type="text"
                          defaultValue={integration.fields.orderId}
                          onChange={(e) => this.updateSelectedWebHook(e.target.value, 'orderId', rowIndex)}/>
                        <Button className="multi_btn margin_bottom_halfem" onClick={() => {this.removeDookFields(rowIndex);}}>-</Button>
                      </div>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.dispatcherId) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <FormControl
                        className="custom-select"
                        componentClass="select"
                        defaultValue="dispatcherId"
                        onChange={(e) => this.setState({fields: e.target.value})}>
                        {                      
                          _.map(options, (option, index) => (
                            <option key={index} value={option}>{option}</option>
                          ))
                        }
                      </FormControl>
                    </Col>
                    <Col sm={6}>
                      <div className="display_flex">
                        <FormControl
                          type="text"
                          defaultValue={integration.fields.dispatcherId}
                          onChange={(e) => this.updateSelectedWebHook(e.target.value, 'dispatcherId', rowIndex)}/>
                        <Button className="multi_btn margin_bottom_halfem" onClick={() => {this.removeDookFields(rowIndex);}}>-</Button>
                      </div>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.role) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <FormControl
                        className="custom-select"
                        componentClass="select"
                        defaultValue="role"
                        onChange={(e) => this.setState({fields: e.target.value})}>
                        {                      
                          _.map(options, (option, index) => (
                            <option key={index} value={option}>{option}</option>
                          ))
                        }
                      </FormControl>
                    </Col>
                    <Col sm={6}>
                      <div className="display_flex">
                        <FormControl
                          type="text"
                          defaultValue={integration.fields.role}
                          onChange={(e) => this.updateSelectedWebHook(e.target.value, 'role', rowIndex)}/>
                        <Button className="multi_btn margin_bottom_halfem" onClick={() => {this.removeDookFields(rowIndex);}}>-</Button>
                      </div>
                    </Col>
                  </Col>
                }
                {
                  !_.isNil(integration.fields.updatedAt) &&
                  <Col sm={12}>
                    <Col sm={6}>
                      <FormControl
                        className="custom-select"
                        componentClass="select"
                        defaultValue="updatedAt"
                        onChange={(e) => this.setState({fields: e.target.value})}>
                        {                      
                          _.map(options, (option, index) => (
                            <option key={index} value={option}>{option}</option>
                          ))
                        }
                      </FormControl>
                    </Col>
                    <Col sm={6}>
                      <div className="display_flex">
                        <FormControl
                          type="text"
                          defaultValue={integration.fields.updatedAt}
                          onChange={(e) => this.updateSelectedWebHook(e.target.value, 'updatedAt', rowIndex)}/>
                        <Button className="multi_btn margin_bottom_halfem" onClick={() => {this.removeDookFields(rowIndex);}}>-</Button>
                      </div>
                    </Col>
                  </Col>
                }                
              </Row>      
            ))
          }
          {/* <Row>
            <Col sm={12}>
              <Button className="float_right_btn" onClick={() => {this.insertNewDookFields();}}>+</Button>
            </Col>
          </Row> */}
        </div>
        <div className="actions">
          <Button bsStyle="primary" onClick={() => this.updateWebHook()}>{gettext('SAVE')}</Button>
        </div>
      </Jumbotron>
    );
  }

  render() {
    const { webHooks, tokens } = this.props;
    const { createWebHook, selectedWebHook, editWebHook } = this.state;

    return (
      <div className="api_component">
        <Jumbotron>
          <div className="item_head_title">
            <h3>{gettext('API-INTEGRATION')}</h3>
          </div>
          <Row className="center_flex">
            <div>
              <CopyToClipboard text={tokens.id}
                onCopy={() => this.props.showMessage({
                  message: gettext('COPIED-TO-CLIPBOARD'),
                  level: 'success'
                })}>
                <Button className="multi_btn margin_bottom_halfem">{tokens.id}</Button>
              </CopyToClipboard>
            </div>
            </Row>
        </Jumbotron>
        {/* <Jumbotron className="hidden">
            <Row className="center_flex">
              <Col sm={10}>
                <Col sm={12}>
                  <div className="table_container">
                    <Table
                      width={300}
                      height={300}
                      headerHeight={20}
                      rowHeight={30}
                      rowClassName={({ index }) => 
                        selectedWebHook
                        && webHooks[index] === selectedWebHook ? 'active' : ''
                      }
                      rowCount={webHooks.length}
                      rowGetter={({ index }) => webHooks[index]}
                      onRowClick={(e) => {
                        this.getSelectedWebHook(e.rowData);
                      }}
                      >
                        <Column
                          label="Company"
                          dataKey="companyId"
                          width={500}
                        />
                        <Column
                          width={500}
                          label="WebHook ID"
                          dataKey="id"
                        />
                    </Table>
                  </div>
                  <div className="milti_controls">
                    <Button className="multi_btn margin_bottom_halfem" onClick={this.flipCreateWebHook}>+</Button>
                    {
                      selectedWebHook &&
                      <DeleteModal
                        delete={this.deleteWebHook}
                        id={selectedWebHook.id}
                        callBack={this.deleteCallback}
                        buttonClass={'multi_btn margin_bottom_halfem'}
                        text="Do you want to delete this item ?"
                        buttonText={'-'}/>
                    }
                  </div>
                </Col>
              </Col>
            </Row>
        </Jumbotron>
        { createWebHook === true ? this.renderCreateWebHooks(): ""}
        { 
          selectedWebHook
            ? editWebHook ? this.renderEditWebHooks() : this.renderWebHooks()
            : ""
        } */}
      </div>
    );
  }
}

ApiComponent.propTypes = {
  webHooks: PropTypes.array
};

function mapStateToProps(state) {
  return {
    webHooks: state.settingsPageReducer.webhooks,
    company: state.appReducer.company,
    companyOrders: state.appReducer.companyOrders,
    dispatchers: state.settingsPageReducer.dispatchers,
    account: state.appReducer.account,
    teams: state.settingsPageReducer.teams,
    userTeams: state.settingsPageReducer.userTeams,
    cities: state.settingsPageReducer.cities,
    tokens: state.appReducer.tokens
  };
}

function mapDispatchToProps(dispatch) {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch),
    appActions:  bindActionCreators(appActions, dispatch),
    fleetActions:  bindActionCreators(fleetActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApiComponent);



// WEBPACK FOOTER //
// ./src/components/settings/components/ApiComponent.js